
<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
    <div>
        <div class="my-3 d-flex justify-content-between">
            <div class="font20">Company Structure Setup</div>
        </div>
    
            <div>
                
            </div>
    </div>
    
    <div class="footer-wrapper mt-auto">
        <hr>
        <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
</section>